var map = {
	"./css/password-protected": [
		65800,
		9,
		65800
	],
	"./css/password-protected.css": [
		65800,
		9,
		65800
	],
	"./fonts/Brandon_bld.otf": [
		44364,
		1,
		44364
	],
	"./fonts/Brandon_bld_it.otf": [
		25634,
		1,
		25634
	],
	"./fonts/Brandon_blk.otf": [
		68055,
		1,
		68055
	],
	"./fonts/Brandon_blk_it.otf": [
		4383,
		1,
		4383
	],
	"./fonts/Brandon_light.otf": [
		71726,
		1,
		71726
	],
	"./fonts/Brandon_light_it.otf": [
		43516,
		1,
		43516
	],
	"./fonts/Brandon_med.otf": [
		64896,
		1,
		64896
	],
	"./fonts/Brandon_med_it.otf": [
		4862,
		1,
		4862
	],
	"./fonts/Brandon_reg.otf": [
		50884,
		1,
		50884
	],
	"./fonts/Brandon_reg_it.otf": [
		40170,
		1,
		40170
	],
	"./fonts/Brandon_thin.otf": [
		27833,
		1,
		27833
	],
	"./fonts/Brandon_thin_it.otf": [
		52113,
		1,
		52113
	],
	"./fonts/Brixton-Lead.ttf": [
		45849,
		1,
		45849
	],
	"./fonts/Fontello/fontello.eot": [
		16343,
		1,
		16343
	],
	"./fonts/Fontello/fontello.svg": [
		60097,
		1,
		60097
	],
	"./fonts/Fontello/fontello.ttf": [
		8329,
		1,
		8329
	],
	"./fonts/Fontello/fontello.woff": [
		84975,
		1,
		84975
	],
	"./fonts/Fontello/fontello.woff2": [
		92191,
		1,
		92191
	],
	"./fonts/P22Underground-Heavy.otf": [
		5862,
		1,
		5862
	],
	"./images/Heart-filled.svg": [
		53755,
		1,
		53755
	],
	"./images/Heart-outline.svg": [
		21519,
		1,
		21519
	],
	"./images/Strawberry_bunch_left.png": [
		37705,
		1,
		37705
	],
	"./images/Strawberry_bunch_right.png": [
		60594,
		1,
		60594
	],
	"./images/archive_icon-copy.svg": [
		62406,
		1,
		62406
	],
	"./images/back-arrow.svg": [
		10811,
		1,
		10811
	],
	"./images/background-blog-desktop.jpg": [
		85895,
		1,
		85895
	],
	"./images/background-desktop.png": [
		4498,
		1,
		4498
	],
	"./images/background-mobile.png": [
		77422,
		1,
		77422
	],
	"./images/background.png": [
		83541,
		1,
		83541
	],
	"./images/beefeater-icon.svg": [
		72975,
		1,
		72975
	],
	"./images/beefeater-logo-image.svg": [
		98213,
		1,
		98213
	],
	"./images/down-arrow.svg": [
		99038,
		1,
		99038
	],
	"./images/eye.svg": [
		26605,
		1,
		26605
	],
	"./images/favourite-icon.svg": [
		26571,
		1,
		26571
	],
	"./images/hamburger.svg": [
		30027,
		1,
		30027
	],
	"./images/heart.svg": [
		80046,
		1,
		80046
	],
	"./images/icon-check.svg": [
		95110,
		1,
		95110
	],
	"./images/icon-copy.svg": [
		88757,
		1,
		88757
	],
	"./images/icon-finish.svg": [
		2975,
		1,
		2975
	],
	"./images/icon-lock.svg": [
		9103,
		1,
		9103
	],
	"./images/icon-nose.svg": [
		395,
		1,
		395
	],
	"./images/icon-palate.svg": [
		13683,
		1,
		13683
	],
	"./images/left-arrow.svg": [
		61413,
		1,
		61413
	],
	"./images/library-images/blue-brick.svg": [
		41909,
		1,
		41909
	],
	"./images/library-images/brick.svg": [
		53844,
		1,
		53844
	],
	"./images/library-images/chevron-library.svg": [
		15092,
		1,
		15092
	],
	"./images/library-images/chevron.svg": [
		60346,
		1,
		60346
	],
	"./images/link 1.svg": [
		29163,
		1,
		29163
	],
	"./images/link-icon.svg": [
		64644,
		1,
		64644
	],
	"./images/link.png": [
		16613,
		1,
		16613
	],
	"./images/mood-quiz/beefeater-sound-on-white.gif": [
		27681,
		1,
		27681
	],
	"./images/mood-quiz/beefeater-sound-on.gif": [
		11645,
		1,
		11645
	],
	"./images/mood-quiz/email.svg": [
		12798,
		1,
		12798
	],
	"./images/mood-quiz/shaker.png": [
		1181,
		1,
		1181
	],
	"./images/mood-quiz/vinyl-2.png": [
		96912,
		1,
		96912
	],
	"./images/mood-quiz/vinyl.png": [
		48561,
		1,
		48561
	],
	"./images/pagination-arrow.svg": [
		51742,
		1,
		51742
	],
	"./images/pattern-bg-desktop.png": [
		70708,
		1,
		70708
	],
	"./images/pattern-bg-mobile.png": [
		80680,
		1,
		80680
	],
	"./images/play-icon.svg": [
		17338,
		1,
		17338
	],
	"./images/quiz-dislike.svg": [
		92047,
		1,
		92047
	],
	"./images/quiz-like.svg": [
		9979,
		1,
		9979
	],
	"./images/quote-pattern.png": [
		96900,
		1,
		96900
	],
	"./images/quotemark.svg": [
		8993,
		1,
		8993
	],
	"./images/right-arrow.svg": [
		84872,
		1,
		84872
	],
	"./images/search-icon.svg": [
		11196,
		1,
		11196
	],
	"./images/select-arrow.svg": [
		50638,
		1,
		50638
	],
	"./images/share-icon.svg": [
		93339,
		1,
		93339
	],
	"./images/share.svg": [
		5799,
		1,
		5799
	],
	"./images/share/facebook.svg": [
		90086,
		1,
		90086
	],
	"./images/share/instagram.svg": [
		91010,
		1,
		91010
	],
	"./images/share/twitter.svg": [
		25651,
		1,
		25651
	],
	"./images/share/whatsapp.svg": [
		96004,
		1,
		96004
	],
	"./images/share/white-icons/facebook-white.svg": [
		33759,
		1,
		33759
	],
	"./images/share/white-icons/twitter-white.svg": [
		32808,
		1,
		32808
	],
	"./images/share/white-icons/whatsapp-white-2.svg": [
		72748,
		1,
		72748
	],
	"./images/share/white-icons/whatsapp-white.svg": [
		55949,
		1,
		55949
	],
	"./images/spinner.svg": [
		31325,
		1,
		31325
	],
	"./images/star.svg": [
		72306,
		1,
		72306
	],
	"./images/tick.svg": [
		88081,
		1,
		88081
	],
	"./images/white-arrow.svg": [
		12645,
		1,
		12645
	],
	"./images/white-glass.png": [
		35765,
		1,
		35765
	],
	"./images/white-glass.svg": [
		60202,
		1,
		60202
	],
	"./js/blocks/accordion": [
		66042,
		9,
		34190,
		61490
	],
	"./js/blocks/accordion.js": [
		66042,
		9,
		34190,
		61490
	],
	"./js/blocks/awards-browser": [
		17677,
		9,
		34190,
		68181
	],
	"./js/blocks/awards-browser.js": [
		17677,
		9,
		34190,
		68181
	],
	"./js/blocks/back-to-top-button": [
		16378,
		9,
		16378
	],
	"./js/blocks/back-to-top-button.js": [
		16378,
		9,
		16378
	],
	"./js/blocks/bambuser-display": [
		90716,
		9,
		90716
	],
	"./js/blocks/bambuser-display.js": [
		90716,
		9,
		90716
	],
	"./js/blocks/better-reviews": [
		36844,
		9,
		34190,
		50900
	],
	"./js/blocks/better-reviews.js": [
		36844,
		9,
		34190,
		50900
	],
	"./js/blocks/betterreviews-display": [
		11544,
		9,
		11544
	],
	"./js/blocks/betterreviews-display.js": [
		11544,
		9,
		11544
	],
	"./js/blocks/blog-grid": [
		69059,
		9,
		69059
	],
	"./js/blocks/blog-grid.js": [
		69059,
		9,
		69059
	],
	"./js/blocks/botanical-scroller": [
		82550,
		9,
		34190,
		15735,
		76979,
		91876
	],
	"./js/blocks/botanical-scroller.js": [
		82550,
		9,
		34190,
		15735,
		76979,
		91876
	],
	"./js/blocks/breadcrumb-display": [
		7296,
		9,
		7296
	],
	"./js/blocks/breadcrumb-display.js": [
		7296,
		9,
		7296
	],
	"./js/blocks/button-test": [
		22703,
		9,
		34190,
		67095
	],
	"./js/blocks/button-test.js": [
		22703,
		9,
		34190,
		67095
	],
	"./js/blocks/carousel-multi-layout-v2": [
		78580,
		9,
		34190,
		64876
	],
	"./js/blocks/carousel-multi-layout-v2.js": [
		78580,
		9,
		34190,
		64876
	],
	"./js/blocks/carousel-multi-layout-v2/carousel-multi-layout-v2-extra": [
		20838,
		9,
		20838
	],
	"./js/blocks/carousel-multi-layout-v2/carousel-multi-layout-v2-extra.js": [
		20838,
		9,
		20838
	],
	"./js/blocks/carousel-slider": [
		65740,
		9,
		34190,
		15735,
		4301,
		89366
	],
	"./js/blocks/carousel-slider.js": [
		65740,
		9,
		34190,
		15735,
		4301,
		89366
	],
	"./js/blocks/carousel-thumbnail-gallery": [
		82798,
		9,
		34190,
		33942
	],
	"./js/blocks/carousel-thumbnail-gallery.js": [
		82798,
		9,
		34190,
		33942
	],
	"./js/blocks/cocktail-browser": [
		2049,
		9,
		34190,
		15735,
		21549
	],
	"./js/blocks/cocktail-browser.js": [
		2049,
		9,
		34190,
		15735,
		21549
	],
	"./js/blocks/cocktail-collection-grid": [
		97226,
		9,
		20641,
		34190,
		53751,
		9410
	],
	"./js/blocks/cocktail-collection-grid.js": [
		97226,
		9,
		20641,
		34190,
		53751,
		9410
	],
	"./js/blocks/cocktail-grid": [
		70301,
		9,
		20641,
		34190,
		53751,
		17682,
		70301
	],
	"./js/blocks/cocktail-grid.js": [
		70301,
		9,
		20641,
		34190,
		53751,
		17682,
		70301
	],
	"./js/blocks/cocktail-info": [
		18421,
		9,
		34190,
		89165
	],
	"./js/blocks/cocktail-info.js": [
		18421,
		9,
		34190,
		89165
	],
	"./js/blocks/cocktail-information": [
		84699,
		9,
		34190,
		15735,
		75971
	],
	"./js/blocks/cocktail-information.js": [
		84699,
		9,
		34190,
		15735,
		75971
	],
	"./js/blocks/contact-us": [
		31021,
		9,
		34190,
		16773
	],
	"./js/blocks/contact-us.js": [
		31021,
		9,
		34190,
		16773
	],
	"./js/blocks/cta-button": [
		68127,
		9,
		34190,
		43479
	],
	"./js/blocks/cta-button.js": [
		68127,
		9,
		34190,
		43479
	],
	"./js/blocks/debrain-wtb": [
		73343,
		9,
		73343
	],
	"./js/blocks/debrain-wtb.js": [
		73343,
		9,
		73343
	],
	"./js/blocks/distillery-banner": [
		71780,
		9,
		34190,
		47164
	],
	"./js/blocks/distillery-banner.js": [
		71780,
		9,
		34190,
		47164
	],
	"./js/blocks/divider": [
		13097,
		9,
		13097
	],
	"./js/blocks/divider.js": [
		13097,
		9,
		13097
	],
	"./js/blocks/dynamic-product": [
		47455,
		9,
		34190,
		73879
	],
	"./js/blocks/dynamic-product.js": [
		47455,
		9,
		34190,
		73879
	],
	"./js/blocks/event-details-banner": [
		92326,
		9,
		92326
	],
	"./js/blocks/event-details-banner.js": [
		92326,
		9,
		92326
	],
	"./js/blocks/featured-collections": [
		69080,
		9,
		34190,
		93552
	],
	"./js/blocks/featured-collections.js": [
		69080,
		9,
		34190,
		93552
	],
	"./js/blocks/filtered-posts": [
		53831,
		9,
		20641,
		34190,
		53751,
		90479
	],
	"./js/blocks/filtered-posts.js": [
		53831,
		9,
		20641,
		34190,
		53751,
		90479
	],
	"./js/blocks/floating-links": [
		94328,
		9,
		94328
	],
	"./js/blocks/floating-links.js": [
		94328,
		9,
		94328
	],
	"./js/blocks/gin-browser": [
		97187,
		9,
		34190,
		15735,
		59371
	],
	"./js/blocks/gin-browser.js": [
		97187,
		9,
		34190,
		15735,
		59371
	],
	"./js/blocks/gradient-layer": [
		19118,
		9,
		19118
	],
	"./js/blocks/gradient-layer.js": [
		19118,
		9,
		19118
	],
	"./js/blocks/grid-designer-v2": [
		37791,
		9,
		37791
	],
	"./js/blocks/grid-designer-v2.js": [
		37791,
		9,
		37791
	],
	"./js/blocks/group-container": [
		33737,
		9,
		33737
	],
	"./js/blocks/group-container.js": [
		33737,
		9,
		33737
	],
	"./js/blocks/half-modules": [
		51419,
		9,
		34190,
		25091
	],
	"./js/blocks/half-modules.js": [
		51419,
		9,
		34190,
		25091
	],
	"./js/blocks/heading-video-quote": [
		10097,
		9,
		4301,
		10097
	],
	"./js/blocks/heading-video-quote.js": [
		10097,
		9,
		4301,
		10097
	],
	"./js/blocks/history-grid": [
		45553,
		9,
		34190,
		95193
	],
	"./js/blocks/history-grid.js": [
		45553,
		9,
		34190,
		95193
	],
	"./js/blocks/iframe-container": [
		53320,
		9,
		53320
	],
	"./js/blocks/iframe-container.js": [
		53320,
		9,
		53320
	],
	"./js/blocks/image-and-caption": [
		31266,
		9,
		34190,
		73786
	],
	"./js/blocks/image-and-caption.js": [
		31266,
		9,
		34190,
		73786
	],
	"./js/blocks/image-and-video": [
		57263,
		9,
		34190,
		4301,
		24439
	],
	"./js/blocks/image-and-video.js": [
		57263,
		9,
		34190,
		4301,
		24439
	],
	"./js/blocks/image-banner": [
		68628,
		9,
		34190,
		62508
	],
	"./js/blocks/image-banner.js": [
		68628,
		9,
		34190,
		62508
	],
	"./js/blocks/info-carousel": [
		81631,
		9,
		34190,
		44638,
		8655
	],
	"./js/blocks/info-carousel.js": [
		81631,
		9,
		34190,
		44638,
		8655
	],
	"./js/blocks/ingredient-configurator": [
		83,
		9,
		34190,
		18619
	],
	"./js/blocks/ingredient-configurator.js": [
		83,
		9,
		34190,
		18619
	],
	"./js/blocks/lightbox": [
		2751,
		9,
		34190,
		41143
	],
	"./js/blocks/lightbox.js": [
		2751,
		9,
		34190,
		41143
	],
	"./js/blocks/map-container": [
		78288,
		9,
		78288
	],
	"./js/blocks/map-container.js": [
		78288,
		9,
		78288
	],
	"./js/blocks/meet-beefeater": [
		71087,
		9,
		71087
	],
	"./js/blocks/meet-beefeater.js": [
		71087,
		9,
		71087
	],
	"./js/blocks/menu-presentation": [
		45242,
		9,
		45242
	],
	"./js/blocks/menu-presentation.js": [
		45242,
		9,
		45242
	],
	"./js/blocks/method-steps": [
		71285,
		9,
		34190,
		15735,
		76979,
		61865
	],
	"./js/blocks/method-steps.js": [
		71285,
		9,
		34190,
		15735,
		76979,
		61865
	],
	"./js/blocks/mikmak-wtb": [
		69154,
		9,
		69154
	],
	"./js/blocks/mikmak-wtb.js": [
		69154,
		9,
		69154
	],
	"./js/blocks/modal": [
		25553,
		9,
		34190,
		30169
	],
	"./js/blocks/modal.js": [
		25553,
		9,
		34190,
		30169
	],
	"./js/blocks/mood-quiz": [
		91111,
		9,
		20641,
		34190,
		53751,
		23839
	],
	"./js/blocks/mood-quiz.js": [
		91111,
		9,
		20641,
		34190,
		53751,
		23839
	],
	"./js/blocks/nav-menu-container": [
		5623,
		9,
		5623
	],
	"./js/blocks/nav-menu-container.js": [
		5623,
		9,
		5623
	],
	"./js/blocks/news-scroller": [
		48540,
		9,
		34190,
		15735,
		64006
	],
	"./js/blocks/news-scroller.js": [
		48540,
		9,
		34190,
		15735,
		64006
	],
	"./js/blocks/newsletter": [
		66221,
		9,
		66221
	],
	"./js/blocks/newsletter-controller": [
		87762,
		9,
		87762
	],
	"./js/blocks/newsletter-controller.js": [
		87762,
		9,
		87762
	],
	"./js/blocks/newsletter.js": [
		66221,
		9,
		66221
	],
	"./js/blocks/nutritional-information": [
		42118,
		9,
		34190,
		13822
	],
	"./js/blocks/nutritional-information.js": [
		42118,
		9,
		34190,
		13822
	],
	"./js/blocks/post-info": [
		10401,
		9,
		10401
	],
	"./js/blocks/post-info.js": [
		10401,
		9,
		10401
	],
	"./js/blocks/post-info/post-info-extra": [
		74988,
		9,
		74988
	],
	"./js/blocks/post-info/post-info-extra.js": [
		74988,
		9,
		74988
	],
	"./js/blocks/post-type-filter-grid-v2": [
		55858,
		9,
		20641,
		34190,
		53751,
		4031,
		83726,
		55858
	],
	"./js/blocks/post-type-filter-grid-v2.js": [
		55858,
		9,
		20641,
		34190,
		53751,
		4031,
		83726,
		55858
	],
	"./js/blocks/post-type-scroller": [
		47868,
		9,
		47868
	],
	"./js/blocks/post-type-scroller.js": [
		47868,
		9,
		47868
	],
	"./js/blocks/product-grid": [
		79612,
		9,
		34190,
		10324
	],
	"./js/blocks/product-grid.js": [
		79612,
		9,
		34190,
		10324
	],
	"./js/blocks/product-information": [
		29388,
		9,
		34190,
		15735,
		60822
	],
	"./js/blocks/product-information.js": [
		29388,
		9,
		34190,
		15735,
		60822
	],
	"./js/blocks/quiz-module": [
		99196,
		9,
		99196
	],
	"./js/blocks/quiz-module.js": [
		99196,
		9,
		99196
	],
	"./js/blocks/recipe-grid": [
		99001,
		9,
		34190,
		48065
	],
	"./js/blocks/recipe-grid.js": [
		99001,
		9,
		34190,
		48065
	],
	"./js/blocks/responsive-image": [
		59036,
		9,
		44066,
		59036
	],
	"./js/blocks/responsive-image.js": [
		59036,
		9,
		44066,
		59036
	],
	"./js/blocks/responsive-table": [
		62905,
		9,
		62905
	],
	"./js/blocks/responsive-table.js": [
		62905,
		9,
		62905
	],
	"./js/blocks/section-separator": [
		21745,
		9,
		21745
	],
	"./js/blocks/section-separator.js": [
		21745,
		9,
		21745
	],
	"./js/blocks/sign-up-banner-v2": [
		97973,
		9,
		97973
	],
	"./js/blocks/sign-up-banner-v2.js": [
		97973,
		9,
		97973
	],
	"./js/blocks/simple-quote": [
		66413,
		9,
		34190,
		87301
	],
	"./js/blocks/simple-quote.js": [
		66413,
		9,
		34190,
		87301
	],
	"./js/blocks/single-column-container": [
		8843,
		9,
		8843
	],
	"./js/blocks/single-column-container.js": [
		8843,
		9,
		8843
	],
	"./js/blocks/single-content-box": [
		21550,
		9,
		21550
	],
	"./js/blocks/single-content-box.js": [
		21550,
		9,
		21550
	],
	"./js/blocks/single-lottie": [
		55352,
		9,
		49891,
		55352
	],
	"./js/blocks/single-lottie.js": [
		55352,
		9,
		49891,
		55352
	],
	"./js/blocks/single-responsive-image": [
		84133,
		9,
		84133
	],
	"./js/blocks/single-responsive-image.js": [
		84133,
		9,
		84133
	],
	"./js/blocks/single-video": [
		17916,
		9,
		4301,
		17916
	],
	"./js/blocks/single-video.js": [
		17916,
		9,
		4301,
		17916
	],
	"./js/blocks/single-video/single-video-extra": [
		86886,
		9,
		86886
	],
	"./js/blocks/single-video/single-video-extra.js": [
		86886,
		9,
		86886
	],
	"./js/blocks/site-copyright-notice": [
		18482,
		9,
		18482
	],
	"./js/blocks/site-copyright-notice.js": [
		18482,
		9,
		18482
	],
	"./js/blocks/site-footer": [
		40897,
		9,
		34190,
		36857
	],
	"./js/blocks/site-footer.js": [
		40897,
		9,
		34190,
		36857
	],
	"./js/blocks/site-logo-container": [
		79619,
		9,
		79619
	],
	"./js/blocks/site-logo-container.js": [
		79619,
		9,
		79619
	],
	"./js/blocks/site-title-and-tagline": [
		31401,
		9,
		31401
	],
	"./js/blocks/site-title-and-tagline.js": [
		31401,
		9,
		31401
	],
	"./js/blocks/sleeknote-form": [
		78330,
		9,
		34190,
		55045
	],
	"./js/blocks/sleeknote-form.js": [
		78330,
		9,
		34190,
		55045
	],
	"./js/blocks/slide-in-panel": [
		7366,
		9,
		7366
	],
	"./js/blocks/slide-in-panel.js": [
		7366,
		9,
		7366
	],
	"./js/blocks/spacer-v2": [
		14967,
		9,
		14967
	],
	"./js/blocks/spacer-v2.js": [
		14967,
		9,
		14967
	],
	"./js/blocks/split-promo-v2": [
		52867,
		9,
		75248
	],
	"./js/blocks/split-promo-v2.js": [
		52867,
		9,
		75248
	],
	"./js/blocks/standard-content-v2": [
		88528,
		9,
		88528
	],
	"./js/blocks/standard-content-v2.js": [
		88528,
		9,
		88528
	],
	"./js/blocks/standard-content-v2/standard-content-v2-extra": [
		71460,
		9,
		71460
	],
	"./js/blocks/standard-content-v2/standard-content-v2-extra.js": [
		71460,
		9,
		71460
	],
	"./js/blocks/sticky-link": [
		77482,
		9,
		77482
	],
	"./js/blocks/sticky-link.js": [
		77482,
		9,
		77482
	],
	"./js/blocks/sub-group-container": [
		67098,
		9,
		67098
	],
	"./js/blocks/sub-group-container.js": [
		67098,
		9,
		67098
	],
	"./js/blocks/sub-tabbed-content": [
		74361,
		9,
		74361
	],
	"./js/blocks/sub-tabbed-content.js": [
		74361,
		9,
		74361
	],
	"./js/blocks/subscribe": [
		59072,
		9,
		34190,
		15112
	],
	"./js/blocks/subscribe.js": [
		59072,
		9,
		34190,
		15112
	],
	"./js/blocks/tabbed-content-v2": [
		81285,
		9,
		81285
	],
	"./js/blocks/tabbed-content-v2.js": [
		81285,
		9,
		81285
	],
	"./js/blocks/test-beefiwyg": [
		19641,
		9,
		34190,
		83553
	],
	"./js/blocks/test-beefiwyg.js": [
		19641,
		9,
		34190,
		83553
	],
	"./js/blocks/text-content": [
		553,
		9,
		34190,
		17825
	],
	"./js/blocks/text-content.js": [
		553,
		9,
		34190,
		17825
	],
	"./js/blocks/theme-switcher": [
		81573,
		9,
		81573
	],
	"./js/blocks/theme-switcher.js": [
		81573,
		9,
		81573
	],
	"./js/blocks/three-part-heading": [
		48019,
		9,
		34190,
		80379
	],
	"./js/blocks/three-part-heading.js": [
		48019,
		9,
		34190,
		80379
	],
	"./js/blocks/typographic-divider": [
		42370,
		9,
		34190,
		83562
	],
	"./js/blocks/typographic-divider.js": [
		42370,
		9,
		34190,
		83562
	],
	"./js/blocks/video-content-grid": [
		16044,
		9,
		4301,
		76979,
		44638,
		29566
	],
	"./js/blocks/video-content-grid.js": [
		16044,
		9,
		4301,
		76979,
		44638,
		29566
	],
	"./js/blocks/video-content-hero": [
		72116,
		9,
		4301,
		72116
	],
	"./js/blocks/video-content-hero.js": [
		72116,
		9,
		4301,
		72116
	],
	"./js/blocks/wishlist": [
		34317,
		9,
		20641,
		34190,
		53751,
		53525
	],
	"./js/blocks/wishlist.js": [
		34317,
		9,
		20641,
		34190,
		53751,
		53525
	],
	"./js/blocks/year-awards": [
		45250,
		9,
		34190,
		24826
	],
	"./js/blocks/year-awards.js": [
		45250,
		9,
		34190,
		24826
	],
	"./js/components/site-header": [
		28397,
		9,
		28397
	],
	"./js/components/site-header.js": [
		28397,
		9,
		28397
	],
	"./js/error": [
		43375,
		7,
		43375
	],
	"./js/error.js": [
		43375,
		7,
		43375
	],
	"./js/main": [
		26966,
		9,
		34190,
		96419,
		26966
	],
	"./js/main.ts": [
		26966,
		9,
		34190,
		96419,
		26966
	],
	"./js/modules/admin": [
		72368,
		7,
		72368
	],
	"./js/modules/admin.js": [
		72368,
		7,
		72368
	],
	"./js/modules/cdb-form": [
		64699,
		9,
		34190,
		96419
	],
	"./js/modules/cdb-form.js": [
		64699,
		9,
		34190,
		96419
	],
	"./js/modules/check-browser-info": [
		62919,
		9,
		62919
	],
	"./js/modules/check-browser-info.js": [
		62919,
		9,
		62919
	],
	"./js/modules/colour-data": [
		66257,
		3,
		66257
	],
	"./js/modules/colour-data-config": [
		32391,
		7,
		32391
	],
	"./js/modules/colour-data-config.js": [
		32391,
		7,
		32391
	],
	"./js/modules/colour-data.json": [
		66257,
		3,
		66257
	],
	"./js/modules/critical": [
		75974,
		7,
		75974
	],
	"./js/modules/critical.js": [
		75974,
		7,
		75974
	],
	"./js/modules/ctbconfig": [
		32170,
		7,
		32170
	],
	"./js/modules/ctbconfig.js": [
		32170,
		7,
		32170
	],
	"./js/modules/helpers": [
		46814,
		9,
		46814
	],
	"./js/modules/helpers.js": [
		46814,
		9,
		46814
	],
	"./js/modules/jsAssets": [
		39629,
		9,
		39629
	],
	"./js/modules/jsAssets.js": [
		39629,
		9,
		39629
	],
	"./js/modules/library-modules/accordion-v2/accordion-v2": [
		82308,
		9,
		82308
	],
	"./js/modules/library-modules/accordion-v2/accordion-v2.js": [
		82308,
		9,
		82308
	],
	"./js/modules/library-modules/buy-now-button/buy-now-button": [
		20606,
		9,
		20606
	],
	"./js/modules/library-modules/buy-now-button/buy-now-button.js": [
		20606,
		9,
		20606
	],
	"./js/modules/library-modules/classic-nav-items-center/classic-nav-items-center": [
		88284,
		9,
		34190,
		19284
	],
	"./js/modules/library-modules/classic-nav-items-center/classic-nav-items-center.js": [
		88284,
		9,
		34190,
		19284
	],
	"./js/modules/library-modules/content-container/content-container": [
		69632,
		9,
		69632
	],
	"./js/modules/library-modules/content-container/content-container.js": [
		69632,
		9,
		69632
	],
	"./js/modules/library-modules/content-tooltip/content-tooltip": [
		95280,
		9,
		95280
	],
	"./js/modules/library-modules/content-tooltip/content-tooltip.js": [
		95280,
		9,
		95280
	],
	"./js/modules/library-modules/core-colour-data-config/core-colour-data-config": [
		79396,
		7,
		79396
	],
	"./js/modules/library-modules/core-colour-data-config/core-colour-data-config.js": [
		79396,
		7,
		79396
	],
	"./js/modules/library-modules/core-editor-cta-style-select/core-editor-cta-style-select": [
		25328,
		9,
		25328
	],
	"./js/modules/library-modules/core-editor-cta-style-select/core-editor-cta-style-select.js": [
		25328,
		9,
		25328
	],
	"./js/modules/library-modules/core-editor-theme-select/core-editor-theme-select": [
		16474,
		9,
		16474
	],
	"./js/modules/library-modules/core-editor-theme-select/core-editor-theme-select.js": [
		16474,
		9,
		16474
	],
	"./js/modules/library-modules/core-wordpress-block-editor-preview/core-wordpress-block-editor-preview": [
		93352,
		9,
		84931,
		93352
	],
	"./js/modules/library-modules/core-wordpress-block-editor-preview/core-wordpress-block-editor-preview.js": [
		93352,
		9,
		84931,
		93352
	],
	"./js/modules/library-modules/countdown/countdown": [
		58480,
		9,
		58480
	],
	"./js/modules/library-modules/countdown/countdown.js": [
		58480,
		9,
		58480
	],
	"./js/modules/library-modules/form-selection/form-selection": [
		74672,
		9,
		74672
	],
	"./js/modules/library-modules/form-selection/form-selection.js": [
		74672,
		9,
		74672
	],
	"./js/modules/library-modules/lottie-animations/lottie-animations": [
		46812,
		9,
		49891,
		46812
	],
	"./js/modules/library-modules/lottie-animations/lottie-animations.js": [
		46812,
		9,
		49891,
		46812
	],
	"./js/modules/library-modules/market-selector/market-selector": [
		18012,
		9,
		18012
	],
	"./js/modules/library-modules/market-selector/market-selector.js": [
		18012,
		9,
		18012
	],
	"./js/modules/library-modules/nav-menu-slide-in-panel/nav-menu-slide-in-panel": [
		35440,
		9,
		35440
	],
	"./js/modules/library-modules/nav-menu-slide-in-panel/nav-menu-slide-in-panel.js": [
		35440,
		9,
		35440
	],
	"./js/modules/library-modules/parallax-animations/parallax-animations": [
		75956,
		9,
		44066,
		75956
	],
	"./js/modules/library-modules/parallax-animations/parallax-animations.js": [
		75956,
		9,
		44066,
		75956
	],
	"./js/modules/library-modules/reservebar-popup/reservebar-popup": [
		91414,
		9,
		91414
	],
	"./js/modules/library-modules/reservebar-popup/reservebar-popup.js": [
		91414,
		9,
		91414
	],
	"./js/modules/library-modules/scrolling-banner/scrolling-banner": [
		33318,
		9,
		34190,
		26654
	],
	"./js/modules/library-modules/scrolling-banner/scrolling-banner.js": [
		33318,
		9,
		34190,
		26654
	],
	"./js/modules/library-modules/scrolling-posts/scrolling-posts": [
		69948,
		9,
		69948
	],
	"./js/modules/library-modules/scrolling-posts/scrolling-posts.js": [
		69948,
		9,
		69948
	],
	"./js/modules/library-modules/shopify/shop": [
		56,
		9,
		56
	],
	"./js/modules/library-modules/shopify/shop-shopify": [
		95023,
		9,
		95023
	],
	"./js/modules/library-modules/shopify/shop-shopify.js": [
		95023,
		9,
		95023
	],
	"./js/modules/library-modules/shopify/shop.js": [
		56,
		9,
		56
	],
	"./js/modules/library-modules/social-media-share/social-media-share": [
		47926,
		9,
		47926
	],
	"./js/modules/library-modules/social-media-share/social-media-share.js": [
		47926,
		9,
		47926
	],
	"./js/modules/modal": [
		98126,
		9,
		98126
	],
	"./js/modules/modal.js": [
		98126,
		9,
		98126
	],
	"./js/modules/perf-tests": [
		8684,
		9,
		8684
	],
	"./js/modules/perf-tests.js": [
		8684,
		9,
		8684
	],
	"./js/modules/polyfills": [
		68955,
		7,
		68955
	],
	"./js/modules/polyfills.js": [
		68955,
		7,
		68955
	],
	"./js/modules/welcome-mat": [
		81056,
		9,
		81056
	],
	"./js/modules/welcome-mat.js": [
		81056,
		9,
		81056
	],
	"./js/modules/wysiwyg": [
		9938,
		7,
		9938
	],
	"./js/modules/wysiwyg.js": [
		9938,
		7,
		9938
	],
	"./scss/admin-style": [
		13197,
		9,
		13197
	],
	"./scss/admin-style.scss": [
		13197,
		9,
		13197
	],
	"./scss/blocks/accordion": [
		37021,
		9,
		27336
	],
	"./scss/blocks/accordion.scss": [
		37021,
		9,
		27336
	],
	"./scss/blocks/accordion/accordion-extra": [
		59251,
		9,
		59372
	],
	"./scss/blocks/accordion/accordion-extra.scss": [
		59251,
		9,
		59372
	],
	"./scss/blocks/award-card": [
		96655,
		9,
		75698
	],
	"./scss/blocks/award-card.scss": [
		96655,
		9,
		75698
	],
	"./scss/blocks/awards-browser": [
		53498,
		9,
		24891
	],
	"./scss/blocks/awards-browser.scss": [
		53498,
		9,
		24891
	],
	"./scss/blocks/back-to-top-button": [
		11945,
		9,
		67920
	],
	"./scss/blocks/back-to-top-button.scss": [
		11945,
		9,
		67920
	],
	"./scss/blocks/back-to-top-button/back-to-top-button-extra": [
		73277,
		9,
		32278
	],
	"./scss/blocks/back-to-top-button/back-to-top-button-extra.scss": [
		73277,
		9,
		32278
	],
	"./scss/blocks/bambuser-display": [
		92591,
		9,
		49142
	],
	"./scss/blocks/bambuser-display.scss": [
		92591,
		9,
		49142
	],
	"./scss/blocks/bambuser-display/bambuser-display-extra": [
		58797,
		9,
		25398
	],
	"./scss/blocks/bambuser-display/bambuser-display-extra.scss": [
		58797,
		9,
		25398
	],
	"./scss/blocks/better-reviews": [
		27715,
		9,
		99854
	],
	"./scss/blocks/better-reviews.scss": [
		27715,
		9,
		99854
	],
	"./scss/blocks/better-reviews/better-reviews-extra": [
		39553,
		9,
		81262
	],
	"./scss/blocks/better-reviews/better-reviews-extra.scss": [
		39553,
		9,
		81262
	],
	"./scss/blocks/betterreviews-display": [
		42527,
		9,
		65426
	],
	"./scss/blocks/betterreviews-display.scss": [
		42527,
		9,
		65426
	],
	"./scss/blocks/betterreviews-display/betterreviews-display-extra": [
		29463,
		9,
		20080
	],
	"./scss/blocks/betterreviews-display/betterreviews-display-extra.scss": [
		29463,
		9,
		20080
	],
	"./scss/blocks/blog-grid": [
		40060,
		9,
		19709
	],
	"./scss/blocks/blog-grid.scss": [
		40060,
		9,
		19709
	],
	"./scss/blocks/blog-grid/blog-grid-extra": [
		48331,
		9,
		3416
	],
	"./scss/blocks/blog-grid/blog-grid-extra.scss": [
		48331,
		9,
		3416
	],
	"./scss/blocks/botanical-scroller": [
		48137,
		9,
		84660
	],
	"./scss/blocks/botanical-scroller.scss": [
		48137,
		9,
		84660
	],
	"./scss/blocks/breadcrumb-display": [
		39415,
		9,
		88754
	],
	"./scss/blocks/breadcrumb-display.scss": [
		39415,
		9,
		88754
	],
	"./scss/blocks/breadcrumb-display/breadcrumb-display-extra": [
		30089,
		9,
		48758
	],
	"./scss/blocks/breadcrumb-display/breadcrumb-display-extra.scss": [
		30089,
		9,
		48758
	],
	"./scss/blocks/button-test": [
		41236,
		9,
		7425
	],
	"./scss/blocks/button-test.scss": [
		41236,
		9,
		7425
	],
	"./scss/blocks/carousel-multi-layout-v2": [
		38831,
		9,
		69998
	],
	"./scss/blocks/carousel-multi-layout-v2.scss": [
		38831,
		9,
		69998
	],
	"./scss/blocks/carousel-multi-layout-v2/carousel-multi-layout-v2-extra": [
		73721,
		9,
		70442
	],
	"./scss/blocks/carousel-multi-layout-v2/carousel-multi-layout-v2-extra.scss": [
		73721,
		9,
		70442
	],
	"./scss/blocks/carousel-slider": [
		98567,
		9,
		46622
	],
	"./scss/blocks/carousel-slider.scss": [
		98567,
		9,
		46622
	],
	"./scss/blocks/carousel-thumbnail-gallery": [
		76781,
		9,
		70828
	],
	"./scss/blocks/carousel-thumbnail-gallery.scss": [
		76781,
		9,
		70828
	],
	"./scss/blocks/carousel-thumbnail-gallery/carousel-thumbnail-gallery-extra": [
		52049,
		9,
		80994
	],
	"./scss/blocks/carousel-thumbnail-gallery/carousel-thumbnail-gallery-extra.scss": [
		52049,
		9,
		80994
	],
	"./scss/blocks/cocktail-browser": [
		77034,
		9,
		12503
	],
	"./scss/blocks/cocktail-browser.scss": [
		77034,
		9,
		12503
	],
	"./scss/blocks/cocktail-card": [
		49988,
		9,
		34161
	],
	"./scss/blocks/cocktail-card.scss": [
		49988,
		9,
		34161
	],
	"./scss/blocks/cocktail-collection-grid": [
		6333,
		9,
		25472
	],
	"./scss/blocks/cocktail-collection-grid.scss": [
		6333,
		9,
		25472
	],
	"./scss/blocks/cocktail-grid": [
		27234,
		9,
		93747
	],
	"./scss/blocks/cocktail-grid.scss": [
		27234,
		9,
		93747
	],
	"./scss/blocks/cocktail-info": [
		69718,
		9,
		7379
	],
	"./scss/blocks/cocktail-info.scss": [
		69718,
		9,
		7379
	],
	"./scss/blocks/cocktail-info/cocktail-info-extra": [
		70023,
		9,
		10040
	],
	"./scss/blocks/cocktail-info/cocktail-info-extra.scss": [
		70023,
		9,
		10040
	],
	"./scss/blocks/cocktail-information": [
		43828,
		9,
		89109
	],
	"./scss/blocks/cocktail-information.scss": [
		43828,
		9,
		89109
	],
	"./scss/blocks/contact-us": [
		52314,
		9,
		50731
	],
	"./scss/blocks/contact-us.scss": [
		52314,
		9,
		50731
	],
	"./scss/blocks/cta-button": [
		89824,
		9,
		60809
	],
	"./scss/blocks/cta-button.scss": [
		89824,
		9,
		60809
	],
	"./scss/blocks/debrain-wtb": [
		50944,
		9,
		41225
	],
	"./scss/blocks/debrain-wtb.scss": [
		50944,
		9,
		41225
	],
	"./scss/blocks/debrain-wtb/debrain-wtb-extra": [
		77259,
		9,
		41792
	],
	"./scss/blocks/debrain-wtb/debrain-wtb-extra.scss": [
		77259,
		9,
		41792
	],
	"./scss/blocks/distillery-banner": [
		42119,
		9,
		86158
	],
	"./scss/blocks/distillery-banner.scss": [
		42119,
		9,
		86158
	],
	"./scss/blocks/divider": [
		56662,
		9,
		89631
	],
	"./scss/blocks/divider.scss": [
		56662,
		9,
		89631
	],
	"./scss/blocks/divider/divider-extra": [
		27491,
		9,
		48648
	],
	"./scss/blocks/divider/divider-extra.scss": [
		27491,
		9,
		48648
	],
	"./scss/blocks/dynamic-product": [
		22704,
		9,
		12969
	],
	"./scss/blocks/dynamic-product.scss": [
		22704,
		9,
		12969
	],
	"./scss/blocks/event-details-banner": [
		28161,
		9,
		88780
	],
	"./scss/blocks/event-details-banner.scss": [
		28161,
		9,
		88780
	],
	"./scss/blocks/event-details-banner/event-details-banner-extra": [
		70409,
		9,
		77902
	],
	"./scss/blocks/event-details-banner/event-details-banner-extra.scss": [
		70409,
		9,
		77902
	],
	"./scss/blocks/featured-collections": [
		66047,
		9,
		79490
	],
	"./scss/blocks/featured-collections.scss": [
		66047,
		9,
		79490
	],
	"./scss/blocks/filtered-posts": [
		51924,
		9,
		22705
	],
	"./scss/blocks/filtered-posts.scss": [
		51924,
		9,
		22705
	],
	"./scss/blocks/floating-links": [
		43531,
		9,
		74474
	],
	"./scss/blocks/floating-links.scss": [
		43531,
		9,
		74474
	],
	"./scss/blocks/floating-links/floating-links-extra": [
		6265,
		9,
		14474
	],
	"./scss/blocks/floating-links/floating-links-extra.scss": [
		6265,
		9,
		14474
	],
	"./scss/blocks/gin-browser": [
		48720,
		9,
		65405
	],
	"./scss/blocks/gin-browser.scss": [
		48720,
		9,
		65405
	],
	"./scss/blocks/gradient-layer": [
		89901,
		9,
		6452
	],
	"./scss/blocks/gradient-layer.scss": [
		89901,
		9,
		6452
	],
	"./scss/blocks/gradient-layer/gradient-layer-extra": [
		9065,
		9,
		69042
	],
	"./scss/blocks/gradient-layer/gradient-layer-extra.scss": [
		9065,
		9,
		69042
	],
	"./scss/blocks/grid-designer-v2": [
		35544,
		9,
		99953
	],
	"./scss/blocks/grid-designer-v2.scss": [
		35544,
		9,
		99953
	],
	"./scss/blocks/grid-designer-v2/grid-designer-v2-extra": [
		50907,
		9,
		88016
	],
	"./scss/blocks/grid-designer-v2/grid-designer-v2-extra.scss": [
		50907,
		9,
		88016
	],
	"./scss/blocks/group-container": [
		2270,
		9,
		15655
	],
	"./scss/blocks/group-container.scss": [
		2270,
		9,
		15655
	],
	"./scss/blocks/group-container/group-container-extra": [
		49563,
		9,
		98400
	],
	"./scss/blocks/group-container/group-container-extra.scss": [
		49563,
		9,
		98400
	],
	"./scss/blocks/half-module": [
		76319,
		9,
		77614
	],
	"./scss/blocks/half-module.scss": [
		76319,
		9,
		77614
	],
	"./scss/blocks/half-modules": [
		81152,
		9,
		501
	],
	"./scss/blocks/half-modules.scss": [
		81152,
		9,
		501
	],
	"./scss/blocks/heading-video-quote": [
		42378,
		9,
		57255
	],
	"./scss/blocks/heading-video-quote.scss": [
		42378,
		9,
		57255
	],
	"./scss/blocks/heading-video-quote/heading-video-quote-extra": [
		93007,
		9,
		93208
	],
	"./scss/blocks/heading-video-quote/heading-video-quote-extra.scss": [
		93007,
		9,
		93208
	],
	"./scss/blocks/history-grid": [
		73262,
		9,
		71095
	],
	"./scss/blocks/history-grid.scss": [
		73262,
		9,
		71095
	],
	"./scss/blocks/iframe-container": [
		76475,
		9,
		17898
	],
	"./scss/blocks/iframe-container.scss": [
		76475,
		9,
		17898
	],
	"./scss/blocks/iframe-container/iframe-container-extra": [
		34409,
		9,
		95242
	],
	"./scss/blocks/iframe-container/iframe-container-extra.scss": [
		34409,
		9,
		95242
	],
	"./scss/blocks/image-and-caption": [
		1537,
		9,
		68576
	],
	"./scss/blocks/image-and-caption.scss": [
		1537,
		9,
		68576
	],
	"./scss/blocks/image-and-video": [
		73924,
		9,
		33457
	],
	"./scss/blocks/image-and-video.scss": [
		73924,
		9,
		33457
	],
	"./scss/blocks/image-banner": [
		19831,
		9,
		60694
	],
	"./scss/blocks/image-banner.scss": [
		19831,
		9,
		60694
	],
	"./scss/blocks/info-carousel": [
		15598,
		9,
		52867
	],
	"./scss/blocks/info-carousel.scss": [
		15598,
		9,
		52867
	],
	"./scss/blocks/ingredient-configurator": [
		1408,
		9,
		74085
	],
	"./scss/blocks/ingredient-configurator.scss": [
		1408,
		9,
		74085
	],
	"./scss/blocks/lightbox": [
		21388,
		9,
		41121
	],
	"./scss/blocks/lightbox.scss": [
		21388,
		9,
		41121
	],
	"./scss/blocks/map-container": [
		40687,
		9,
		76954
	],
	"./scss/blocks/map-container.scss": [
		40687,
		9,
		76954
	],
	"./scss/blocks/map-container/map-container-extra": [
		73835,
		9,
		73292
	],
	"./scss/blocks/map-container/map-container-extra.scss": [
		73835,
		9,
		73292
	],
	"./scss/blocks/meet-beefeater": [
		54972,
		9,
		1865
	],
	"./scss/blocks/meet-beefeater.scss": [
		54972,
		9,
		1865
	],
	"./scss/blocks/meet-beefeater/meet-beefeater-extra": [
		31835,
		9,
		22148
	],
	"./scss/blocks/meet-beefeater/meet-beefeater-extra.scss": [
		31835,
		9,
		22148
	],
	"./scss/blocks/menu-presentation": [
		12997,
		9,
		22744
	],
	"./scss/blocks/menu-presentation.scss": [
		12997,
		9,
		22744
	],
	"./scss/blocks/menu-presentation/menu-presentation-extra": [
		70571,
		9,
		62844
	],
	"./scss/blocks/menu-presentation/menu-presentation-extra.scss": [
		70571,
		9,
		62844
	],
	"./scss/blocks/method-steps": [
		75178,
		9,
		76819
	],
	"./scss/blocks/method-steps.scss": [
		75178,
		9,
		76819
	],
	"./scss/blocks/mikmak-wtb": [
		33057,
		9,
		44832
	],
	"./scss/blocks/mikmak-wtb.scss": [
		33057,
		9,
		44832
	],
	"./scss/blocks/mikmak-wtb/mikmak-wtb-extra": [
		11469,
		9,
		94142
	],
	"./scss/blocks/mikmak-wtb/mikmak-wtb-extra.scss": [
		11469,
		9,
		94142
	],
	"./scss/blocks/modal": [
		75578,
		9,
		80519
	],
	"./scss/blocks/modal.scss": [
		75578,
		9,
		80519
	],
	"./scss/blocks/mood-quiz": [
		66912,
		9,
		12513
	],
	"./scss/blocks/mood-quiz.scss": [
		66912,
		9,
		12513
	],
	"./scss/blocks/mood-quiz/ginerating": [
		42117,
		9,
		63094
	],
	"./scss/blocks/mood-quiz/ginerating.scss": [
		42117,
		9,
		63094
	],
	"./scss/blocks/mood-quiz/homepage": [
		35869,
		9,
		24782
	],
	"./scss/blocks/mood-quiz/homepage.scss": [
		35869,
		9,
		24782
	],
	"./scss/blocks/mood-quiz/intro": [
		25777,
		9,
		39874
	],
	"./scss/blocks/mood-quiz/intro.scss": [
		25777,
		9,
		39874
	],
	"./scss/blocks/mood-quiz/question1": [
		94156,
		9,
		11743
	],
	"./scss/blocks/mood-quiz/question1.scss": [
		94156,
		9,
		11743
	],
	"./scss/blocks/mood-quiz/question2": [
		20721,
		9,
		78402
	],
	"./scss/blocks/mood-quiz/question2.scss": [
		20721,
		9,
		78402
	],
	"./scss/blocks/mood-quiz/question3": [
		30786,
		9,
		77201
	],
	"./scss/blocks/mood-quiz/question3.scss": [
		30786,
		9,
		77201
	],
	"./scss/blocks/mood-quiz/results": [
		26157,
		9,
		10430
	],
	"./scss/blocks/mood-quiz/results.scss": [
		26157,
		9,
		10430
	],
	"./scss/blocks/mood-quiz/results2": [
		51845,
		9,
		27414
	],
	"./scss/blocks/mood-quiz/results2.scss": [
		51845,
		9,
		27414
	],
	"./scss/blocks/nav-menu-container": [
		43672,
		9,
		6897
	],
	"./scss/blocks/nav-menu-container.scss": [
		43672,
		9,
		6897
	],
	"./scss/blocks/nav-menu-container/nav-menu-container-extra": [
		70587,
		9,
		50096
	],
	"./scss/blocks/nav-menu-container/nav-menu-container-extra.scss": [
		70587,
		9,
		50096
	],
	"./scss/blocks/news-scroller": [
		29567,
		9,
		11582
	],
	"./scss/blocks/news-scroller.scss": [
		29567,
		9,
		11582
	],
	"./scss/blocks/newsletter": [
		44438,
		9,
		20907
	],
	"./scss/blocks/newsletter.scss": [
		44438,
		9,
		20907
	],
	"./scss/blocks/newsletter/newsletter-extra": [
		35007,
		9,
		92056
	],
	"./scss/blocks/newsletter/newsletter-extra.scss": [
		35007,
		9,
		92056
	],
	"./scss/blocks/nutritional-card": [
		26451,
		9,
		32022
	],
	"./scss/blocks/nutritional-card.scss": [
		26451,
		9,
		32022
	],
	"./scss/blocks/nutritional-information": [
		55977,
		9,
		68044
	],
	"./scss/blocks/nutritional-information.scss": [
		55977,
		9,
		68044
	],
	"./scss/blocks/post-info": [
		39050,
		9,
		82663
	],
	"./scss/blocks/post-info.scss": [
		39050,
		9,
		82663
	],
	"./scss/blocks/post-info/post-info-extra": [
		39791,
		9,
		35800
	],
	"./scss/blocks/post-info/post-info-extra.scss": [
		39791,
		9,
		35800
	],
	"./scss/blocks/post-type-filter-grid-v2": [
		67441,
		9,
		85648
	],
	"./scss/blocks/post-type-filter-grid-v2.scss": [
		67441,
		9,
		85648
	],
	"./scss/blocks/post-type-filter-grid-v2/post-type-filter-grid-v2-extra": [
		38457,
		9,
		44650
	],
	"./scss/blocks/post-type-filter-grid-v2/post-type-filter-grid-v2-extra.scss": [
		38457,
		9,
		44650
	],
	"./scss/blocks/post-type-scroller": [
		5335,
		9,
		25942
	],
	"./scss/blocks/post-type-scroller.scss": [
		5335,
		9,
		25942
	],
	"./scss/blocks/post-type-scroller/post-type-scroller-extra": [
		95645,
		9,
		8782
	],
	"./scss/blocks/post-type-scroller/post-type-scroller-extra.scss": [
		95645,
		9,
		8782
	],
	"./scss/blocks/product-card": [
		84313,
		9,
		23260
	],
	"./scss/blocks/product-card.scss": [
		84313,
		9,
		23260
	],
	"./scss/blocks/product-details/product-details-extra": [
		16443,
		9,
		3000
	],
	"./scss/blocks/product-details/product-details-extra.scss": [
		16443,
		9,
		3000
	],
	"./scss/blocks/product-grid": [
		11519,
		9,
		32110
	],
	"./scss/blocks/product-grid.scss": [
		11519,
		9,
		32110
	],
	"./scss/blocks/product-information": [
		57547,
		9,
		30910
	],
	"./scss/blocks/product-information.scss": [
		57547,
		9,
		30910
	],
	"./scss/blocks/quiz-module": [
		37503,
		9,
		51422
	],
	"./scss/blocks/quiz-module.scss": [
		37503,
		9,
		51422
	],
	"./scss/blocks/quiz-module/quiz-module-extra": [
		59471,
		9,
		8252
	],
	"./scss/blocks/quiz-module/quiz-module-extra.scss": [
		59471,
		9,
		8252
	],
	"./scss/blocks/recipe-grid": [
		72262,
		9,
		74055
	],
	"./scss/blocks/recipe-grid.scss": [
		72262,
		9,
		74055
	],
	"./scss/blocks/recipe-grid/recipe-grid-extra": [
		92083,
		9,
		12224
	],
	"./scss/blocks/recipe-grid/recipe-grid-extra.scss": [
		92083,
		9,
		12224
	],
	"./scss/blocks/responsive-image": [
		68567,
		9,
		99518
	],
	"./scss/blocks/responsive-image.scss": [
		68567,
		9,
		99518
	],
	"./scss/blocks/responsive-table": [
		30270,
		9,
		9759
	],
	"./scss/blocks/responsive-table.scss": [
		30270,
		9,
		9759
	],
	"./scss/blocks/responsive-table/responsive-table-extra": [
		45675,
		9,
		83544
	],
	"./scss/blocks/responsive-table/responsive-table-extra.scss": [
		45675,
		9,
		83544
	],
	"./scss/blocks/section-container/section-container-extra": [
		30319,
		9,
		56648
	],
	"./scss/blocks/section-container/section-container-extra.scss": [
		30319,
		9,
		56648
	],
	"./scss/blocks/section-separator": [
		63942,
		9,
		1383
	],
	"./scss/blocks/section-separator.scss": [
		63942,
		9,
		1383
	],
	"./scss/blocks/sign-up-banner-v2": [
		35558,
		9,
		96651
	],
	"./scss/blocks/sign-up-banner-v2.scss": [
		35558,
		9,
		96651
	],
	"./scss/blocks/sign-up-banner-v2/sign-up-banner-v2-extra": [
		96999,
		9,
		16184
	],
	"./scss/blocks/sign-up-banner-v2/sign-up-banner-v2-extra.scss": [
		96999,
		9,
		16184
	],
	"./scss/blocks/simple-quote": [
		49638,
		9,
		8459
	],
	"./scss/blocks/simple-quote.scss": [
		49638,
		9,
		8459
	],
	"./scss/blocks/single-column-container": [
		15516,
		9,
		5781
	],
	"./scss/blocks/single-column-container.scss": [
		15516,
		9,
		5781
	],
	"./scss/blocks/single-column-container/single-column-container-extra": [
		35531,
		9,
		28336
	],
	"./scss/blocks/single-column-container/single-column-container-extra.scss": [
		35531,
		9,
		28336
	],
	"./scss/blocks/single-content-box": [
		7297,
		9,
		36748
	],
	"./scss/blocks/single-content-box.scss": [
		7297,
		9,
		36748
	],
	"./scss/blocks/single-content-box/single-content-box-extra": [
		29089,
		9,
		5598
	],
	"./scss/blocks/single-content-box/single-content-box-extra.scss": [
		29089,
		9,
		5598
	],
	"./scss/blocks/single-lottie": [
		84635,
		9,
		50154
	],
	"./scss/blocks/single-lottie.scss": [
		84635,
		9,
		50154
	],
	"./scss/blocks/single-lottie/single-lottie-extra": [
		56615,
		9,
		61796
	],
	"./scss/blocks/single-lottie/single-lottie-extra.scss": [
		56615,
		9,
		61796
	],
	"./scss/blocks/single-responsive-image": [
		67298,
		9,
		93707
	],
	"./scss/blocks/single-responsive-image.scss": [
		67298,
		9,
		93707
	],
	"./scss/blocks/single-responsive-image/single-responsive-image-extra": [
		65235,
		9,
		92728
	],
	"./scss/blocks/single-responsive-image/single-responsive-image-extra.scss": [
		65235,
		9,
		92728
	],
	"./scss/blocks/single-video": [
		54871,
		9,
		48126
	],
	"./scss/blocks/single-video.scss": [
		54871,
		9,
		48126
	],
	"./scss/blocks/single-video/single-video-extra": [
		32049,
		9,
		10922
	],
	"./scss/blocks/single-video/single-video-extra.scss": [
		32049,
		9,
		10922
	],
	"./scss/blocks/site-copyright-notice": [
		14997,
		9,
		2312
	],
	"./scss/blocks/site-copyright-notice.scss": [
		14997,
		9,
		2312
	],
	"./scss/blocks/site-copyright-notice/site-copyright-notice-extra": [
		76883,
		9,
		99004
	],
	"./scss/blocks/site-copyright-notice/site-copyright-notice-extra.scss": [
		76883,
		9,
		99004
	],
	"./scss/blocks/site-footer": [
		57858,
		9,
		15015
	],
	"./scss/blocks/site-footer.scss": [
		57858,
		9,
		15015
	],
	"./scss/blocks/site-logo-container": [
		86116,
		9,
		61525
	],
	"./scss/blocks/site-logo-container.scss": [
		86116,
		9,
		61525
	],
	"./scss/blocks/site-logo-container/site-logo-container-extra": [
		85859,
		9,
		66272
	],
	"./scss/blocks/site-logo-container/site-logo-container-extra.scss": [
		85859,
		9,
		66272
	],
	"./scss/blocks/site-title-and-tagline": [
		37554,
		9,
		84343
	],
	"./scss/blocks/site-title-and-tagline.scss": [
		37554,
		9,
		84343
	],
	"./scss/blocks/site-title-and-tagline/site-title-and-tagline-extra": [
		15463,
		9,
		18304
	],
	"./scss/blocks/site-title-and-tagline/site-title-and-tagline-extra.scss": [
		15463,
		9,
		18304
	],
	"./scss/blocks/sleeknote-form": [
		25706,
		9,
		45395
	],
	"./scss/blocks/sleeknote-form.scss": [
		25706,
		9,
		45395
	],
	"./scss/blocks/slide-in-panel": [
		61353,
		9,
		45668
	],
	"./scss/blocks/slide-in-panel.scss": [
		61353,
		9,
		45668
	],
	"./scss/blocks/slide-in-panel/slide-in-panel-extra": [
		30585,
		9,
		44454
	],
	"./scss/blocks/slide-in-panel/slide-in-panel-extra.scss": [
		30585,
		9,
		44454
	],
	"./scss/blocks/spacer-v2": [
		6936,
		9,
		569
	],
	"./scss/blocks/spacer-v2.scss": [
		6936,
		9,
		569
	],
	"./scss/blocks/split-promo-v2": [
		21620,
		9,
		77429
	],
	"./scss/blocks/split-promo-v2.scss": [
		21620,
		9,
		77429
	],
	"./scss/blocks/split-promo-v2/split-promo-v2-extra": [
		27987,
		9,
		83872
	],
	"./scss/blocks/split-promo-v2/split-promo-v2-extra.scss": [
		27987,
		9,
		83872
	],
	"./scss/blocks/standard-content-v2": [
		60503,
		9,
		1242
	],
	"./scss/blocks/standard-content-v2.scss": [
		60503,
		9,
		1242
	],
	"./scss/blocks/standard-content-v2/standard-content-v2-extra": [
		57879,
		9,
		68736
	],
	"./scss/blocks/standard-content-v2/standard-content-v2-extra.scss": [
		57879,
		9,
		68736
	],
	"./scss/blocks/sticky-link": [
		66537,
		9,
		19272
	],
	"./scss/blocks/sticky-link.scss": [
		66537,
		9,
		19272
	],
	"./scss/blocks/sticky-link/sticky-link-extra": [
		3919,
		9,
		35868
	],
	"./scss/blocks/sticky-link/sticky-link-extra.scss": [
		3919,
		9,
		35868
	],
	"./scss/blocks/sub-group-container": [
		94221,
		9,
		10320
	],
	"./scss/blocks/sub-group-container.scss": [
		94221,
		9,
		10320
	],
	"./scss/blocks/sub-group-container/sub-group-container-extra": [
		71919,
		9,
		11960
	],
	"./scss/blocks/sub-group-container/sub-group-container-extra.scss": [
		71919,
		9,
		11960
	],
	"./scss/blocks/sub-tabbed-content": [
		71498,
		9,
		39111
	],
	"./scss/blocks/sub-tabbed-content.scss": [
		71498,
		9,
		39111
	],
	"./scss/blocks/sub-tabbed-content/sub-tabbed-content-extra": [
		11375,
		9,
		47888
	],
	"./scss/blocks/sub-tabbed-content/sub-tabbed-content-extra.scss": [
		11375,
		9,
		47888
	],
	"./scss/blocks/subscribe": [
		91683,
		9,
		19666
	],
	"./scss/blocks/subscribe.scss": [
		91683,
		9,
		19666
	],
	"./scss/blocks/tabbed-content-v2": [
		74922,
		9,
		35515
	],
	"./scss/blocks/tabbed-content-v2.scss": [
		74922,
		9,
		35515
	],
	"./scss/blocks/tabbed-content-v2/tabbed-content-v2-extra": [
		53563,
		9,
		27064
	],
	"./scss/blocks/tabbed-content-v2/tabbed-content-v2-extra.scss": [
		53563,
		9,
		27064
	],
	"./scss/blocks/test-beefiwyg": [
		88986,
		9,
		58263
	],
	"./scss/blocks/test-beefiwyg.scss": [
		88986,
		9,
		58263
	],
	"./scss/blocks/text-content": [
		35466,
		9,
		38263
	],
	"./scss/blocks/text-content.scss": [
		35466,
		9,
		38263
	],
	"./scss/blocks/theme-switcher": [
		46486,
		9,
		64659
	],
	"./scss/blocks/theme-switcher.scss": [
		46486,
		9,
		64659
	],
	"./scss/blocks/theme-switcher/theme-switcher-extra": [
		91383,
		9,
		21176
	],
	"./scss/blocks/theme-switcher/theme-switcher-extra.scss": [
		91383,
		9,
		21176
	],
	"./scss/blocks/three-part-heading": [
		35884,
		9,
		8181
	],
	"./scss/blocks/three-part-heading.scss": [
		35884,
		9,
		8181
	],
	"./scss/blocks/typographic-divider": [
		43373,
		9,
		85328
	],
	"./scss/blocks/typographic-divider.scss": [
		43373,
		9,
		85328
	],
	"./scss/blocks/video-content-grid": [
		83651,
		9,
		2390
	],
	"./scss/blocks/video-content-grid.scss": [
		83651,
		9,
		2390
	],
	"./scss/blocks/video-content-grid/video-content-grid-extra": [
		41789,
		9,
		35226
	],
	"./scss/blocks/video-content-grid/video-content-grid-extra.scss": [
		41789,
		9,
		35226
	],
	"./scss/blocks/video-content-hero": [
		2491,
		9,
		71582
	],
	"./scss/blocks/video-content-hero.scss": [
		2491,
		9,
		71582
	],
	"./scss/blocks/video-content-hero/video-content-hero-extra": [
		68245,
		9,
		15490
	],
	"./scss/blocks/video-content-hero/video-content-hero-extra.scss": [
		68245,
		9,
		15490
	],
	"./scss/blocks/wishlist": [
		15042,
		9,
		76771
	],
	"./scss/blocks/wishlist.scss": [
		15042,
		9,
		76771
	],
	"./scss/blocks/year-awards": [
		52469,
		9,
		18656
	],
	"./scss/blocks/year-awards.scss": [
		52469,
		9,
		18656
	],
	"./scss/components/accent-text/accent-text-extra": [
		81345,
		9,
		81345
	],
	"./scss/components/accent-text/accent-text-extra.scss": [
		81345,
		9,
		81345
	],
	"./scss/components/agegateV2": [
		14109,
		9,
		14109
	],
	"./scss/components/agegateV2.scss": [
		14109,
		9,
		14109
	],
	"./scss/components/better-reviews/better-reviews-extra": [
		44687,
		9,
		44687
	],
	"./scss/components/better-reviews/better-reviews-extra.scss": [
		44687,
		9,
		44687
	],
	"./scss/components/countdown/countdown-extra": [
		90761,
		9,
		90761
	],
	"./scss/components/countdown/countdown-extra.scss": [
		90761,
		9,
		90761
	],
	"./scss/components/form-selection/form-selection-extra": [
		31721,
		9,
		31721
	],
	"./scss/components/form-selection/form-selection-extra.scss": [
		31721,
		9,
		31721
	],
	"./scss/components/forms/form": [
		97289,
		9,
		97289
	],
	"./scss/components/forms/form.scss": [
		97289,
		9,
		97289
	],
	"./scss/components/lottie-animations/lottie-animations-extra": [
		32429,
		9,
		32429
	],
	"./scss/components/lottie-animations/lottie-animations-extra.scss": [
		32429,
		9,
		32429
	],
	"./scss/components/modal": [
		41628,
		9,
		41628
	],
	"./scss/components/modal.scss": [
		41628,
		9,
		41628
	],
	"./scss/components/nav-menu-slide-in-panel/nav-menu-slide-in-panel-extra": [
		84721,
		9,
		84721
	],
	"./scss/components/nav-menu-slide-in-panel/nav-menu-slide-in-panel-extra.scss": [
		84721,
		9,
		84721
	],
	"./scss/components/reviews": [
		48836,
		9,
		48836
	],
	"./scss/components/reviews.scss": [
		48836,
		9,
		48836
	],
	"./scss/components/scrolling-banner/scrolling-banner-extra": [
		94251,
		9,
		94251
	],
	"./scss/components/scrolling-banner/scrolling-banner-extra.scss": [
		94251,
		9,
		94251
	],
	"./scss/components/site-header": [
		73822,
		9,
		73822
	],
	"./scss/components/site-header.scss": [
		73822,
		9,
		73822
	],
	"./scss/components/social-media-share/social-media-share-extra": [
		36439,
		9,
		36439
	],
	"./scss/components/social-media-share/social-media-share-extra.scss": [
		36439,
		9,
		36439
	],
	"./scss/forms/form": [
		64032,
		9,
		64032
	],
	"./scss/forms/form.scss": [
		64032,
		9,
		64032
	],
	"./scss/forms/newsletter": [
		37853,
		9,
		37853
	],
	"./scss/forms/newsletter.scss": [
		37853,
		9,
		37853
	],
	"./scss/modules/critical": [
		67345,
		9,
		67345
	],
	"./scss/modules/critical.scss": [
		67345,
		9,
		67345
	],
	"./scss/modules/dynamicBlocksPreview": [
		35829,
		9,
		35829
	],
	"./scss/modules/dynamicBlocksPreview.scss": [
		35829,
		9,
		35829
	],
	"./scss/modules/library-modules/accent-text/accent-text": [
		23095,
		9,
		23095
	],
	"./scss/modules/library-modules/accent-text/accent-text-extra": [
		20380,
		9,
		20380
	],
	"./scss/modules/library-modules/accent-text/accent-text-extra.scss": [
		20380,
		9,
		20380
	],
	"./scss/modules/library-modules/accent-text/accent-text.scss": [
		23095,
		9,
		23095
	],
	"./scss/modules/library-modules/accordion-v2/accordion-v2": [
		40355,
		9,
		40355
	],
	"./scss/modules/library-modules/accordion-v2/accordion-v2-extra": [
		73760,
		9,
		73760
	],
	"./scss/modules/library-modules/accordion-v2/accordion-v2-extra.scss": [
		73760,
		9,
		73760
	],
	"./scss/modules/library-modules/accordion-v2/accordion-v2.scss": [
		40355,
		9,
		40355
	],
	"./scss/modules/library-modules/animations/animations": [
		34639,
		9,
		34639
	],
	"./scss/modules/library-modules/animations/animations.scss": [
		34639,
		9,
		34639
	],
	"./scss/modules/library-modules/bazaarvoice-review/bazaarvoice-review": [
		45113,
		9,
		45113
	],
	"./scss/modules/library-modules/bazaarvoice-review/bazaarvoice-review.scss": [
		45113,
		9,
		45113
	],
	"./scss/modules/library-modules/better-reviews/better-reviews": [
		96777,
		9,
		96777
	],
	"./scss/modules/library-modules/better-reviews/better-reviews-extra": [
		65538,
		9,
		65538
	],
	"./scss/modules/library-modules/better-reviews/better-reviews-extra.scss": [
		65538,
		9,
		65538
	],
	"./scss/modules/library-modules/better-reviews/better-reviews.scss": [
		96777,
		9,
		96777
	],
	"./scss/modules/library-modules/block-padding/block-padding": [
		2759,
		9,
		2759
	],
	"./scss/modules/library-modules/block-padding/block-padding.scss": [
		2759,
		9,
		2759
	],
	"./scss/modules/library-modules/block-settings/block-settings": [
		73331,
		9,
		73331
	],
	"./scss/modules/library-modules/block-settings/block-settings.scss": [
		73331,
		9,
		73331
	],
	"./scss/modules/library-modules/blockquote/blockquote": [
		95247,
		9,
		95247
	],
	"./scss/modules/library-modules/blockquote/blockquote.scss": [
		95247,
		9,
		95247
	],
	"./scss/modules/library-modules/box-shadow/box-shadow": [
		79653,
		9,
		79653
	],
	"./scss/modules/library-modules/box-shadow/box-shadow.scss": [
		79653,
		9,
		79653
	],
	"./scss/modules/library-modules/classic-nav-items-center/classic-nav-items-center": [
		78627,
		9,
		78627
	],
	"./scss/modules/library-modules/classic-nav-items-center/classic-nav-items-center.scss": [
		78627,
		9,
		78627
	],
	"./scss/modules/library-modules/code-block/code-block": [
		42059,
		9,
		42059
	],
	"./scss/modules/library-modules/code-block/code-block.scss": [
		42059,
		9,
		42059
	],
	"./scss/modules/library-modules/content-container-settings/content-container-settings": [
		67711,
		9,
		67711
	],
	"./scss/modules/library-modules/content-container-settings/content-container-settings.scss": [
		67711,
		9,
		67711
	],
	"./scss/modules/library-modules/content-container/content-container": [
		36255,
		9,
		36255
	],
	"./scss/modules/library-modules/content-container/content-container.scss": [
		36255,
		9,
		36255
	],
	"./scss/modules/library-modules/content-image-v2/content-image": [
		33454,
		9,
		33454
	],
	"./scss/modules/library-modules/content-image-v2/content-image-v2": [
		94405,
		9,
		94405
	],
	"./scss/modules/library-modules/content-image-v2/content-image-v2.scss": [
		94405,
		9,
		94405
	],
	"./scss/modules/library-modules/content-image-v2/content-image.scss": [
		33454,
		9,
		33454
	],
	"./scss/modules/library-modules/content-image/content-image": [
		56283,
		9,
		56283
	],
	"./scss/modules/library-modules/content-image/content-image.scss": [
		56283,
		9,
		56283
	],
	"./scss/modules/library-modules/content-tooltip/content-tooltip": [
		40959,
		9,
		40959
	],
	"./scss/modules/library-modules/content-tooltip/content-tooltip.scss": [
		40959,
		9,
		40959
	],
	"./scss/modules/library-modules/core-critical/core-critical": [
		89055,
		9,
		89055
	],
	"./scss/modules/library-modules/core-critical/core-critical.scss": [
		89055,
		9,
		89055
	],
	"./scss/modules/library-modules/core-css-modules/core-css-modules": [
		77131,
		9,
		77131
	],
	"./scss/modules/library-modules/core-css-modules/core-css-modules.scss": [
		77131,
		9,
		77131
	],
	"./scss/modules/library-modules/core-css-sizing-vars/core-css-sizing-vars": [
		92871,
		9,
		92871
	],
	"./scss/modules/library-modules/core-css-sizing-vars/core-css-sizing-vars.scss": [
		92871,
		9,
		92871
	],
	"./scss/modules/library-modules/core-cta/core-cta": [
		22009,
		9,
		22009
	],
	"./scss/modules/library-modules/core-cta/core-cta.scss": [
		22009,
		9,
		22009
	],
	"./scss/modules/library-modules/core-functions/core-functions": [
		97199,
		9,
		97199
	],
	"./scss/modules/library-modules/core-functions/core-functions.scss": [
		97199,
		9,
		97199
	],
	"./scss/modules/library-modules/core-generic/core-generic": [
		33679,
		9,
		33679
	],
	"./scss/modules/library-modules/core-generic/core-generic.scss": [
		33679,
		9,
		33679
	],
	"./scss/modules/library-modules/core-gradient-designer/core-gradient-designer": [
		28461,
		9,
		28461
	],
	"./scss/modules/library-modules/core-gradient-designer/core-gradient-designer.scss": [
		28461,
		9,
		28461
	],
	"./scss/modules/library-modules/core-mixins/core-mixins": [
		51531,
		9,
		51531
	],
	"./scss/modules/library-modules/core-mixins/core-mixins.scss": [
		51531,
		9,
		51531
	],
	"./scss/modules/library-modules/core-root-variables/core-root-variables": [
		82139,
		9,
		82139
	],
	"./scss/modules/library-modules/core-root-variables/core-root-variables.scss": [
		82139,
		9,
		82139
	],
	"./scss/modules/library-modules/core-typography/core-typography": [
		22559,
		9,
		22559
	],
	"./scss/modules/library-modules/core-typography/core-typography.scss": [
		22559,
		9,
		22559
	],
	"./scss/modules/library-modules/core-wordpress-block-editor-preview/core-wordpress-block-editor-preview": [
		87975,
		9,
		87975
	],
	"./scss/modules/library-modules/core-wordpress-block-editor-preview/core-wordpress-block-editor-preview.scss": [
		87975,
		9,
		87975
	],
	"./scss/modules/library-modules/countdown/countdown": [
		71455,
		9,
		71455
	],
	"./scss/modules/library-modules/countdown/countdown-extra": [
		13476,
		9,
		13476
	],
	"./scss/modules/library-modules/countdown/countdown-extra.scss": [
		13476,
		9,
		13476
	],
	"./scss/modules/library-modules/countdown/countdown.scss": [
		71455,
		9,
		71455
	],
	"./scss/modules/library-modules/cover-link/cover-link": [
		51313,
		9,
		51313
	],
	"./scss/modules/library-modules/cover-link/cover-link.scss": [
		51313,
		9,
		51313
	],
	"./scss/modules/library-modules/element-positioning/element-positioning": [
		19523,
		9,
		19523
	],
	"./scss/modules/library-modules/element-positioning/element-positioning.scss": [
		19523,
		9,
		19523
	],
	"./scss/modules/library-modules/form-selection/form-selection": [
		21551,
		9,
		21551
	],
	"./scss/modules/library-modules/form-selection/form-selection-extra": [
		7796,
		9,
		7796
	],
	"./scss/modules/library-modules/form-selection/form-selection-extra.scss": [
		7796,
		9,
		7796
	],
	"./scss/modules/library-modules/form-selection/form-selection.scss": [
		21551,
		9,
		21551
	],
	"./scss/modules/library-modules/gradient-overlay/gradient-overlay": [
		46915,
		9,
		46915
	],
	"./scss/modules/library-modules/gradient-overlay/gradient-overlay.scss": [
		46915,
		9,
		46915
	],
	"./scss/modules/library-modules/grid-layout-container/grid-layout-container": [
		81879,
		9,
		81879
	],
	"./scss/modules/library-modules/grid-layout-container/grid-layout-container.scss": [
		81879,
		9,
		81879
	],
	"./scss/modules/library-modules/grid-layout-element/grid-layout-element": [
		12775,
		9,
		12775
	],
	"./scss/modules/library-modules/grid-layout-element/grid-layout-element.scss": [
		12775,
		9,
		12775
	],
	"./scss/modules/library-modules/lottie-animations/lottie-animations": [
		83291,
		9,
		83291
	],
	"./scss/modules/library-modules/lottie-animations/lottie-animations-extra": [
		41336,
		9,
		41336
	],
	"./scss/modules/library-modules/lottie-animations/lottie-animations-extra.scss": [
		41336,
		9,
		41336
	],
	"./scss/modules/library-modules/lottie-animations/lottie-animations.scss": [
		83291,
		9,
		83291
	],
	"./scss/modules/library-modules/market-selector/market-selector": [
		70787,
		9,
		70787
	],
	"./scss/modules/library-modules/market-selector/market-selector-extra": [
		78816,
		9,
		78816
	],
	"./scss/modules/library-modules/market-selector/market-selector-extra.scss": [
		78816,
		9,
		78816
	],
	"./scss/modules/library-modules/market-selector/market-selector.scss": [
		70787,
		9,
		70787
	],
	"./scss/modules/library-modules/nav-menu-slide-in-panel/nav-menu-slide-in-panel": [
		62535,
		9,
		62535
	],
	"./scss/modules/library-modules/nav-menu-slide-in-panel/nav-menu-slide-in-panel-extra": [
		95564,
		9,
		95564
	],
	"./scss/modules/library-modules/nav-menu-slide-in-panel/nav-menu-slide-in-panel-extra.scss": [
		95564,
		9,
		95564
	],
	"./scss/modules/library-modules/nav-menu-slide-in-panel/nav-menu-slide-in-panel.scss": [
		62535,
		9,
		62535
	],
	"./scss/modules/library-modules/nav-menu/nav-menu": [
		44975,
		9,
		44975
	],
	"./scss/modules/library-modules/nav-menu/nav-menu.scss": [
		44975,
		9,
		44975
	],
	"./scss/modules/library-modules/post-author/post-author": [
		91243,
		9,
		91243
	],
	"./scss/modules/library-modules/post-author/post-author.scss": [
		91243,
		9,
		91243
	],
	"./scss/modules/library-modules/reservebar-popup/reservebar-popup": [
		52453,
		9,
		52453
	],
	"./scss/modules/library-modules/reservebar-popup/reservebar-popup.scss": [
		52453,
		9,
		52453
	],
	"./scss/modules/library-modules/responsive-image/responsive-image": [
		37829,
		9,
		37829
	],
	"./scss/modules/library-modules/responsive-image/responsive-image.scss": [
		37829,
		9,
		37829
	],
	"./scss/modules/library-modules/responsive-video/responsive-video": [
		33125,
		9,
		33125
	],
	"./scss/modules/library-modules/responsive-video/responsive-video.scss": [
		33125,
		9,
		33125
	],
	"./scss/modules/library-modules/scrolling-banner/scrolling-banner": [
		56229,
		9,
		56229
	],
	"./scss/modules/library-modules/scrolling-banner/scrolling-banner-extra": [
		4246,
		9,
		4246
	],
	"./scss/modules/library-modules/scrolling-banner/scrolling-banner-extra.scss": [
		4246,
		9,
		4246
	],
	"./scss/modules/library-modules/scrolling-banner/scrolling-banner.scss": [
		56229,
		9,
		56229
	],
	"./scss/modules/library-modules/scrolling-posts/scrolling-posts": [
		84915,
		9,
		84915
	],
	"./scss/modules/library-modules/scrolling-posts/scrolling-posts.scss": [
		84915,
		9,
		84915
	],
	"./scss/modules/library-modules/shopify/buybutton": [
		92813,
		9,
		92813
	],
	"./scss/modules/library-modules/shopify/buybutton.scss": [
		92813,
		9,
		92813
	],
	"./scss/modules/library-modules/shopify/shopify": [
		7951,
		9,
		59859
	],
	"./scss/modules/library-modules/shopify/shopify.scss": [
		7951,
		9,
		59859
	],
	"./scss/modules/library-modules/social-media-share/social-media-share": [
		13061,
		9,
		13061
	],
	"./scss/modules/library-modules/social-media-share/social-media-share-extra": [
		66454,
		9,
		66454
	],
	"./scss/modules/library-modules/social-media-share/social-media-share-extra.scss": [
		66454,
		9,
		66454
	],
	"./scss/modules/library-modules/social-media-share/social-media-share.scss": [
		13061,
		9,
		13061
	],
	"./scss/modules/library-modules/social-networks/social-networks": [
		48683,
		9,
		48683
	],
	"./scss/modules/library-modules/social-networks/social-networks.scss": [
		48683,
		9,
		48683
	],
	"./scss/modules/library-modules/truncated-text/truncated-text": [
		90097,
		9,
		90097
	],
	"./scss/modules/library-modules/truncated-text/truncated-text-extra": [
		50218,
		9,
		50218
	],
	"./scss/modules/library-modules/truncated-text/truncated-text-extra.scss": [
		50218,
		9,
		50218
	],
	"./scss/modules/library-modules/truncated-text/truncated-text.scss": [
		90097,
		9,
		90097
	],
	"./scss/modules/wysiwyg": [
		56077,
		9,
		56077
	],
	"./scss/modules/wysiwyg.scss": [
		56077,
		9,
		56077
	],
	"./scss/pages/drink": [
		93919,
		9,
		93919
	],
	"./scss/pages/drink.scss": [
		93919,
		9,
		93919
	],
	"./scss/pages/error": [
		52143,
		9,
		52143
	],
	"./scss/pages/error.scss": [
		52143,
		9,
		52143
	],
	"./scss/theme/animations": [
		59155,
		9,
		59155
	],
	"./scss/theme/animations.scss": [
		59155,
		9,
		59155
	],
	"./scss/theme/beefiwyg": [
		31954,
		9,
		31954
	],
	"./scss/theme/beefiwyg.scss": [
		31954,
		9,
		31954
	],
	"./scss/theme/breakpoints": [
		53848,
		9,
		53848
	],
	"./scss/theme/breakpoints.scss": [
		53848,
		9,
		53848
	],
	"./scss/theme/buttons": [
		43633,
		9,
		43633
	],
	"./scss/theme/buttons.scss": [
		43633,
		9,
		43633
	],
	"./scss/theme/font-face": [
		47177,
		9,
		47177
	],
	"./scss/theme/font-face.scss": [
		47177,
		9,
		47177
	],
	"./scss/theme/fonts": [
		57866,
		9,
		57866
	],
	"./scss/theme/fonts.scss": [
		57866,
		9,
		57866
	],
	"./scss/theme/form": [
		34630,
		9,
		34630
	],
	"./scss/theme/form.scss": [
		34630,
		9,
		34630
	],
	"./scss/theme/generic": [
		9777,
		9,
		9777
	],
	"./scss/theme/generic.scss": [
		9777,
		9,
		9777
	],
	"./scss/theme/iconbuttons": [
		96438,
		9,
		96438
	],
	"./scss/theme/iconbuttons.scss": [
		96438,
		9,
		96438
	],
	"./scss/theme/icons": [
		64742,
		9,
		64742
	],
	"./scss/theme/icons.scss": [
		64742,
		9,
		64742
	],
	"./scss/theme/mixins": [
		16954,
		9,
		16954
	],
	"./scss/theme/mixins.scss": [
		16954,
		9,
		16954
	],
	"./scss/theme/reset": [
		88039,
		9,
		88039
	],
	"./scss/theme/reset.scss": [
		88039,
		9,
		88039
	],
	"./scss/theme/swipermodules": [
		58337,
		9,
		58337
	],
	"./scss/theme/swipermodules.scss": [
		58337,
		9,
		58337
	],
	"./scss/theme/table": [
		70036,
		9,
		70036
	],
	"./scss/theme/table.scss": [
		70036,
		9,
		70036
	],
	"./scss/theme/typography": [
		24873,
		9,
		24873
	],
	"./scss/theme/typography.scss": [
		24873,
		9,
		24873
	],
	"./scss/theme/variables": [
		94749,
		9,
		94749
	],
	"./scss/theme/variables.scss": [
		94749,
		9,
		94749
	],
	"./vue/blocks/cocktail-collection-grid.vue": [
		26134,
		9,
		20641,
		26134
	],
	"./vue/blocks/cocktail-grid.vue": [
		98122,
		9,
		20641,
		34190,
		53751,
		17682
	],
	"./vue/blocks/filtered-posts.vue": [
		3770,
		9,
		20641,
		34190,
		53751,
		23842
	],
	"./vue/blocks/mood-quiz.vue": [
		99334,
		9,
		20641,
		53751,
		99334
	],
	"./vue/blocks/mood-quiz/background.vue": [
		55935,
		9,
		20641,
		55935
	],
	"./vue/blocks/mood-quiz/ginerating.vue": [
		1471,
		9,
		20641,
		1471
	],
	"./vue/blocks/mood-quiz/homepage.vue": [
		69638,
		9,
		20641,
		53751,
		69638
	],
	"./vue/blocks/mood-quiz/intro.vue": [
		45073,
		9,
		20641,
		45073
	],
	"./vue/blocks/mood-quiz/lamp.vue": [
		52459,
		9,
		20641,
		52459
	],
	"./vue/blocks/mood-quiz/question1.vue": [
		47677,
		9,
		20641,
		47677
	],
	"./vue/blocks/mood-quiz/question2.vue": [
		63338,
		9,
		20641,
		63338
	],
	"./vue/blocks/mood-quiz/question3.vue": [
		46862,
		9,
		20641,
		46862
	],
	"./vue/blocks/mood-quiz/results.vue": [
		13748,
		9,
		20641,
		13748
	],
	"./vue/blocks/mood-quiz/results2.vue": [
		44103,
		9,
		20641,
		53751,
		44103
	],
	"./vue/blocks/post-type-filter-grid-v2.vue": [
		85958,
		9,
		20641,
		34190,
		53751,
		4031,
		83726
	],
	"./vue/blocks/post-type-filter-grid-v2/article-details.vue": [
		6794,
		9,
		20641,
		6794
	],
	"./vue/blocks/post-type-filter-grid-v2/better-reviews-widget.vue": [
		80066,
		9,
		20641,
		80066
	],
	"./vue/blocks/post-type-filter-grid-v2/buy-now-widget.vue": [
		60863,
		9,
		20641,
		60863
	],
	"./vue/blocks/post-type-filter-grid-v2/cocktail-category.vue": [
		48299,
		9,
		20641,
		48299
	],
	"./vue/blocks/post-type-filter-grid-v2/cocktail-details.vue": [
		99086,
		9,
		20641,
		99086
	],
	"./vue/blocks/post-type-filter-grid-v2/cocktail-tasting-notes.vue": [
		22280,
		9,
		20641,
		22280
	],
	"./vue/blocks/post-type-filter-grid-v2/divider-widget.vue": [
		54365,
		9,
		20641,
		54365
	],
	"./vue/blocks/post-type-filter-grid-v2/drink-tastes.vue": [
		81393,
		9,
		20641,
		81393
	],
	"./vue/blocks/post-type-filter-grid-v2/featured-post-component.vue": [
		97307,
		9,
		20641,
		97307
	],
	"./vue/blocks/post-type-filter-grid-v2/global-image-widget.vue": [
		93051,
		9,
		20641,
		93051
	],
	"./vue/blocks/post-type-filter-grid-v2/media-widget.vue": [
		88934,
		9,
		20641,
		88934
	],
	"./vue/blocks/post-type-filter-grid-v2/person-email-widget.vue": [
		32990,
		9,
		20641,
		32990
	],
	"./vue/blocks/post-type-filter-grid-v2/person-name-widget.vue": [
		52623,
		9,
		20641,
		52623
	],
	"./vue/blocks/post-type-filter-grid-v2/person-questionaire-widget.vue": [
		29827,
		9,
		20641,
		29827
	],
	"./vue/blocks/post-type-filter-grid-v2/person-rating-widget.vue": [
		32322,
		9,
		20641,
		32322
	],
	"./vue/blocks/post-type-filter-grid-v2/post-author-widget.vue": [
		46426,
		9,
		20641,
		46426
	],
	"./vue/blocks/post-type-filter-grid-v2/post-category-widget.vue": [
		64156,
		9,
		20641,
		64156
	],
	"./vue/blocks/post-type-filter-grid-v2/post-component.vue": [
		4031,
		9,
		20641,
		4031
	],
	"./vue/blocks/post-type-filter-grid-v2/post-details.vue": [
		87493,
		9,
		20641,
		87493
	],
	"./vue/blocks/post-type-filter-grid-v2/post-headline-widget.vue": [
		48154,
		9,
		20641,
		48154
	],
	"./vue/blocks/post-type-filter-grid-v2/post-image-widget.vue": [
		79539,
		9,
		20641,
		79539
	],
	"./vue/blocks/post-type-filter-grid-v2/post-info-description.vue": [
		67338,
		9,
		20641,
		67338
	],
	"./vue/blocks/post-type-filter-grid-v2/post-info-subtitle.vue": [
		9524,
		9,
		20641,
		9524
	],
	"./vue/blocks/post-type-filter-grid-v2/post-link-widget.vue": [
		98103,
		9,
		20641,
		98103
	],
	"./vue/blocks/post-type-filter-grid-v2/post-publish-widget.vue": [
		6036,
		9,
		20641,
		6036
	],
	"./vue/blocks/post-type-filter-grid-v2/post-review-widget.vue": [
		18870,
		9,
		20641,
		18870
	],
	"./vue/blocks/post-type-filter-grid-v2/post-tags-widget.vue": [
		18038,
		9,
		20641,
		18038
	],
	"./vue/blocks/post-type-filter-grid-v2/post-text-alternative-style.vue": [
		47682,
		9,
		20641,
		47682
	],
	"./vue/blocks/post-type-filter-grid-v2/post-title-widget.vue": [
		21266,
		9,
		20641,
		21266
	],
	"./vue/blocks/post-type-filter-grid-v2/product-abv.vue": [
		773,
		9,
		20641,
		773
	],
	"./vue/blocks/post-type-filter-grid-v2/product-age-statement.vue": [
		58173,
		9,
		20641,
		58173
	],
	"./vue/blocks/post-type-filter-grid-v2/product-bazaarvoice.vue": [
		44137,
		9,
		20641,
		44137
	],
	"./vue/blocks/post-type-filter-grid-v2/product-brand.vue": [
		5439,
		9,
		20641,
		5439
	],
	"./vue/blocks/post-type-filter-grid-v2/product-cask-type.vue": [
		86121,
		9,
		20641,
		86121
	],
	"./vue/blocks/post-type-filter-grid-v2/product-country.vue": [
		62551,
		9,
		20641,
		62551
	],
	"./vue/blocks/post-type-filter-grid-v2/product-description.vue": [
		19187,
		9,
		20641,
		19187
	],
	"./vue/blocks/post-type-filter-grid-v2/product-details-name.vue": [
		49895,
		9,
		20641,
		49895
	],
	"./vue/blocks/post-type-filter-grid-v2/product-details-price.vue": [
		69358,
		9,
		20641,
		69358
	],
	"./vue/blocks/post-type-filter-grid-v2/product-details.vue": [
		98146,
		9,
		20641,
		98146
	],
	"./vue/blocks/post-type-filter-grid-v2/product-finish.vue": [
		70936,
		9,
		20641,
		70936
	],
	"./vue/blocks/post-type-filter-grid-v2/product-history.vue": [
		96745,
		9,
		20641,
		96745
	],
	"./vue/blocks/post-type-filter-grid-v2/product-link.vue": [
		36297,
		9,
		20641,
		36297
	],
	"./vue/blocks/post-type-filter-grid-v2/product-logo-widget.vue": [
		30303,
		9,
		20641,
		30303
	],
	"./vue/blocks/post-type-filter-grid-v2/product-name.vue": [
		38666,
		9,
		20641,
		38666
	],
	"./vue/blocks/post-type-filter-grid-v2/product-nose.vue": [
		6609,
		9,
		20641,
		6609
	],
	"./vue/blocks/post-type-filter-grid-v2/product-price.vue": [
		25900,
		9,
		20641,
		25900
	],
	"./vue/blocks/post-type-filter-grid-v2/product-slug.vue": [
		18086,
		9,
		20641,
		18086
	],
	"./vue/blocks/post-type-filter-grid-v2/product-taste.vue": [
		90162,
		9,
		20641,
		90162
	],
	"./vue/blocks/post-type-filter-grid-v2/product-whiskey-type.vue": [
		32694,
		9,
		20641,
		32694
	],
	"./vue/blocks/post-type-filter-grid-v2/product-whisky-type.vue": [
		4762,
		9,
		20641,
		4762
	],
	"./vue/blocks/post-type-filter-grid-v2/ptfg-utils.vue": [
		43570,
		9,
		43570
	],
	"./vue/blocks/post-type-filter-grid-v2/shopify-add-to-cart.vue": [
		68910,
		9,
		20641,
		68910
	],
	"./vue/blocks/post-type-filter-grid-v2/social-media-item.vue": [
		52060,
		9,
		20641,
		52060
	],
	"./vue/blocks/post-type-filter-grid-v2/spacer-widget.vue": [
		29701,
		9,
		20641,
		29701
	],
	"./vue/blocks/post-type-filter-grid-v2/text-search.vue": [
		18267,
		9,
		20641,
		53751,
		18267
	],
	"./vue/blocks/post-type-filter-grid-v2/treat-details.vue": [
		32039,
		9,
		20641,
		32039
	],
	"./vue/blocks/wishlist.vue": [
		9079,
		9,
		20641,
		9079
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80793;
module.exports = webpackAsyncContext;